module.exports = __webpack_public_path__ + "static/media/iconSettingsF.fc1e8ac3.svg";